import { ws_init, ws_send, ws_close } from '../tools/soket'
import {useRoute} from "vue-router";
import pamComon from '@/views/pam/common/index.js'
import {isNotEmpty} from "../tools/utils";
import {getHostData} from "../apis/getHostData";
const channelOptions = {
    wsurl: '',
    ws: null,
    hartbeat: {},
    new_message: {},
    messages: [],
    on: true,
}

function fetchUserBase() {
    return localStorage.getItem('userBase') ? JSON.parse(localStorage.getItem('userBase')) : {}
}
const state = () => ({
    channel: Object.assign({}, channelOptions)
})

const getters = {
    getWSurl: state => state.channel.wsurl,
    getChannel: state => state.channel.ws,
    getHartbeat: state => state.channel.hartbeat,
    getNewMessage: state => state.channel.new_message,
    getMessages: state => state.channel.messages,
    isChannelOn: state => state.channel.on,
    getStateCode: state => state.channel.code,
}

const mutations = {
    ['set_message'](state, data) {
        state.channel.new_message = data
        state.channel.messages.push(data)
    },
    ['update_channel_options'](state) {
        state.channel.wsurl = getHostData().VUE_APP_SOCKETSERVERHOST+'/websocket/'+fetchUserBase().mark
        state.channel.hartbeat = { event: "ping"}
    },
}

const command_mapping = {
    ...pamComon.commandMapping
}
/**
 * 随机生成索引
 * @param min 最小值
 * @param max 最大值
 * @param i 当前获取位置
 */
function RandomIndex(min, max, i){
    let index = Math.floor(Math.random()*(max-min+1)+min),
        numStart = "abacdefghjklmnopqrstuvwxyzABCDEFGHJKLMNOPQRSTUVWXYZ0123456789".length - 10;
    //如果字符串第一位是数字，则递归重新获取
    if(i==0&&index>=numStart){
        index = RandomIndex(min, max, i);
    }
    //返回最终索引值
    return index;
}
/**
 * 随机生成字符串
 * @param len 指定生成字符串长度
 */
function getRandomString(len){
    let min = 0, max = "abacdefghjklmnopqrstuvwxyzABCDEFGHJKLMNOPQRSTUVWXYZ0123456789".length-1, _str = '';
    //判断是否指定长度，否则默认长度为15
    len = len || 15;
    //循环生成字符串
    for(var i = 0, index; i < len; i++){
        index = RandomIndex(min, max, i);
        _str += "abacdefghjklmnopqrstuvwxyzABCDEFGHJKLMNOPQRSTUVWXYZ0123456789"[index];
    }
    return _str;
}

function fetchUserNameForWS() {
    let key = localStorage.getItem('user-key')
    if(!key){
        key = getRandomString(5)
        localStorage.setItem('user-key',key)
    }
    return fetchUserBase().id+'%'+fetchUserBase().username + (key ? ('%' + key) : '')
}

const actions = {
    //只需要在登录后初始化一次即可
    async ['socket_init']({ state, commit, dispatch }) {
        dispatch('netmanager/setup', null, {root: true})
        commit('update_channel_options')
        ws_init();
    },
    async ['socket_send']({ state, dispatch }, payload) {
        payload['for'] = fetchUserNameForWS()
        //加入到管理堆栈
        dispatch('netmanager/net_request', {api: payload.data.run,routePath:window.location.hash}, {root: true})
        ws_send(JSON.stringify(payload))
    },
    async ['socket_close']({ state, dispatch }) {
        ws_close()
        dispatch('netmanager/stop', null, {root: true})
    },
    async ['socket_message']({ commit, dispatch }, payload) {
        if(payload.event=='result'){
            console.log(payload);
        }
        if(payload.event=='result' && isNotEmpty(payload?.data?.result?.run)){
            dispatch('netmanager/net_sucess', {api: payload?.data?.result?.run}, {root: true});

            dispatch(`${command_mapping[payload?.data?.result?.run]}`, payload.data, { root: true })
        }
    },
    async ['socket_msg_timeout']({ commit, dispatch }, payload) {
        dispatch(`${command_mapping[payload.command]}`, payload.message, { root: true })
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
